/**
 * What 3 Ingredients - Cookie Consent Banner Module
 * GDPR & Google AdSense compliant cookie consent banner.
 */

export function initCookieConsent(onOpenPrivacyModal) {
  const consent = localStorage.getItem('cookie_consent');
  if (consent === 'accepted') return;

  const banner = document.createElement('div');
  banner.id = 'cookie-banner';
  banner.className = 'cookie-banner no-print';
  banner.innerHTML = `
    <div class="cookie-banner-content">
      <p class="cookie-text">
        We use cookies for Google AdSense analytics and performance to keep What 3 Ingredients 100% free. 
        <a href="#" id="cookie-privacy-link">Learn more</a>.
      </p>
      <div class="cookie-buttons">
        <button id="accept-cookies-btn" class="btn btn-primary btn-sm">Accept</button>
      </div>
    </div>
  `;

  document.body.appendChild(banner);

  document.getElementById('accept-cookies-btn').addEventListener('click', () => {
    localStorage.setItem('cookie_consent', 'accepted');
    banner.classList.add('cookie-banner-fadeout');
    setTimeout(() => banner.remove(), 300);
  });

  document.getElementById('cookie-privacy-link').addEventListener('click', (e) => {
    e.preventDefault();
    if (onOpenPrivacyModal) onOpenPrivacyModal('privacy');
  });
}
